export default {
  USER: 'user',
  ROUTER_SNAPSHOT: 'routerSnapshot',
  AGREEMENTS: 'agreements',
  CONTRACTS: 'contracts',
  SELECTED_CONTRACT_ID: 'selectedContractId',
  PREVIOUS_CONTRACT_ID: 'previousContractId',
};
